var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMegaphone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3407 14.0543C15.295 14.0543 15.2493 14.0478 15.205 14.0354L0.527871 9.79533C0.318478 9.73467 0.174316 9.54289 0.174316 9.32502V6.3896C0.174316 6.17172 0.318478 5.97994 0.527871 5.91928L15.205 1.67923C15.3524 1.63813 15.5122 1.66553 15.6348 1.75816C15.7575 1.85079 15.8299 1.99625 15.8299 2.14955V13.5651C15.8299 13.7184 15.7575 13.8638 15.6348 13.9565C15.5487 14.0204 15.4457 14.0543 15.3407 14.0543ZM1.15279 8.95711L14.8514 12.9147V2.7999L1.15279 6.7575V8.95711Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3408 14.3798C15.0707 14.3798 14.8516 14.1606 14.8516 13.8906V1.82273C14.8516 1.55267 15.0707 1.3335 15.3408 1.3335C15.6109 1.3335 15.83 1.55267 15.83 1.82273V13.8906C15.83 14.1606 15.6109 14.3798 15.3408 14.3798Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.663553 10.4658C0.393494 10.4658 0.174316 10.2467 0.174316 9.9766V5.73655C0.174316 5.46649 0.393494 5.24731 0.663553 5.24731C0.933612 5.24731 1.15279 5.46649 1.15279 5.73655V9.9766C1.15279 10.2467 0.933612 10.4658 0.663553 10.4658Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55603 13.7273C4.02766 13.7273 2.78369 12.4839 2.78369 10.9549C2.78369 10.6594 2.8274 10.3789 2.9135 10.1213C2.99896 9.86489 3.27358 9.72595 3.53255 9.8127C3.78891 9.89816 3.9272 10.1754 3.84175 10.4318C3.78891 10.5883 3.76216 10.7651 3.76216 10.9549C3.76216 11.9445 4.56712 12.7488 5.55603 12.7488C6.3786 12.7488 7.11115 12.1695 7.29706 11.3717C7.35838 11.1095 7.62191 10.9438 7.88479 11.0064C8.14833 11.0684 8.31141 11.3313 8.25009 11.5942C7.95655 12.8499 6.84892 13.7273 5.55603 13.7273Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMegaphone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/megaphone.174d43b9.svg";
export { ForwardRef as ReactComponent };